import React from 'react';
import { useSelector } from 'react-redux';
import { selectors } from '@src/containers/ProfileVenue';
import FilesList from '..';

const FilesListConnector = () => {
	const files = useSelector(selectors.mappedFiles);
	return <FilesList files={files} />;
};

export default FilesListConnector;
